(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-cleanses-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcFaqInit) return; root.__gcFaqInit = true;
    root.querySelectorAll('[data-gc-faq-item]').forEach(function (item) {
      var head = item.querySelector('[data-gc-faq-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        root.querySelectorAll('[data-gc-faq-item]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }
  function boot() { document.querySelectorAll('[data-gc-faq]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-coaching-approach"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcApproachInit) return; root.__gcApproachInit = true;
    root.querySelectorAll('[data-gc-step]').forEach(function (step) {
      var head = step.querySelector('[data-gc-step-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var was = step.classList.contains('is-open');
        root.querySelectorAll('[data-gc-step]').forEach(function (s) { s.classList.remove('is-open'); });
        if (!was) step.classList.add('is-open');
      });
    });
  }
  function boot() { document.querySelectorAll('[data-gc-approach]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-coaching-consult"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcConsultInit) return; root.__gcConsultInit = true;
    root.querySelectorAll('[data-gc-row]').forEach(function (row) {
      var head = row.querySelector('[data-gc-row-toggle]');
      if (!head) return;
      head.addEventListener('click', function () { row.classList.toggle('is-open'); });
    });
  }
  function boot() { document.querySelectorAll('[data-gc-consult]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-custom-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gchInit) return;
    root.__gchInit = true;

    var items = root.querySelectorAll('[data-gc-menu]');
    var drops = root.querySelectorAll('[data-gc-drop]');
    var nav = root.querySelector('.gc-nav');
    var timer = null;

    function anyOpen() {
      for (var i = 0; i < drops.length; i++) {
        if (drops[i].classList.contains('is-open')) return true;
      }
      return false;
    }
    function reTint() {
      root.classList.toggle('is-tinted', window.scrollY > 100 || anyOpen() || root.__hover || root.__searchOpen);
    }

    var announce = root.querySelector('.gc-header__announce');
    function measureAnnounce() {
      if (announce) root.style.setProperty('--gc-announce-h', announce.offsetHeight + 'px');
    }
    function reChrome() {
      if (!announce) return;
      if (window.scrollY > 80) root.classList.add('is-condensed');
      else if (window.scrollY <= 10) root.classList.remove('is-condensed');
    }
    function onScroll() { reTint(); reChrome(); }

    function openMenu(key) {
      clearTimeout(timer);
      items.forEach(function (item) { item.classList.toggle('is-open', item.getAttribute('data-gc-menu') === key); });
      drops.forEach(function (drop) { drop.classList.toggle('is-open', drop.getAttribute('data-gc-drop') === key); });
      var activeItem = root.querySelector('[data-gc-menu="' + key + '"]');
      var activeDrop = root.querySelector('[data-gc-drop="' + key + '"]');
      if (activeItem && activeDrop && activeDrop.classList.contains('gc-small') && nav) {
        var itemRect = activeItem.getBoundingClientRect();
        var navRect = nav.getBoundingClientRect();
        var dropWidth = activeDrop.offsetWidth;
        var proposedLeft = itemRect.left - navRect.left + (itemRect.width / 2) - (dropWidth / 2);
        var maxLeft = navRect.width - dropWidth - 20;
        var safeLeft = Math.max(20, Math.min(proposedLeft, maxLeft));
        activeDrop.style.left = safeLeft + 'px';
        activeDrop.style.right = 'auto';
      }
      root.classList.add('is-tinted');
    }
    function closeSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        items.forEach(function (item) { item.classList.remove('is-open'); });
        drops.forEach(function (drop) { drop.classList.remove('is-open'); });
        reTint();
      }, 120);
    }

    items.forEach(function (item) {
      var key = item.getAttribute('data-gc-menu');
      item.addEventListener('mouseenter', function () { openMenu(key); });
      item.addEventListener('mouseleave', closeSoon);
    });
    drops.forEach(function (drop) {
      drop.addEventListener('mouseenter', function () { openMenu(drop.getAttribute('data-gc-drop')); });
      drop.addEventListener('mouseleave', closeSoon);
    });

    if (nav) {
      nav.addEventListener('mouseenter', function () { root.__hover = true; root.classList.add('is-tinted'); });
      nav.addEventListener('mouseleave', function () { root.__hover = false; reTint(); });
    }

    var burger = root.querySelector('[data-gc-burger]');
    var panel = root.querySelector('[data-gc-mobile]');
    if (burger && panel) {
      burger.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        root.classList.toggle('is-tinted', open || window.scrollY > 100);
      });
    }

    var search = root.querySelector('[data-gc-search]');
    var searchToggle = root.querySelector('[data-gc-search-toggle]');
    var searchClose = root.querySelector('[data-gc-search-close]');
    function setSearch(open) {
      if (!search || !searchToggle) return;
      search.hidden = !open;
      root.__searchOpen = open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      reTint();
      if (open) {
        var input = search.querySelector('input[type="search"]');
        if (input) window.setTimeout(function () { input.focus(); }, 20);
      }
    }
    if (searchToggle) searchToggle.addEventListener('click', function () { setSearch(search.hidden); });
    if (searchClose) searchClose.addEventListener('click', function () { setSearch(false); searchToggle.focus(); });
    root.addEventListener('keydown', function (event) { if (event.key === 'Escape') setSearch(false); });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measureAnnounce, { passive: true });
    measureAnnounce();
    onScroll();
  }

  function boot() { document.querySelectorAll('[data-gc-header]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-home-cleanse-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCleanse(root) {
    if (!root || root.__gcCleanseInit) return;
    root.__gcCleanseInit = true;

    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-gc-tier]'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-gc-img]'));
    var capName = root.querySelector('[data-gc-cap-name]');
    var capSub = root.querySelector('[data-gc-cap-sub]');
    if (tiers.length < 2) return;

    function activate(index) {
      imgs.forEach(function (img) {
        img.classList.toggle('is-active', String(index) === img.getAttribute('data-index'));
      });
      var tier = tiers[index];
      if (tier && capName) capName.textContent = tier.getAttribute('data-name') || '';
      if (tier && capSub) capSub.textContent = tier.getAttribute('data-sub') || '';
    }

    tiers.forEach(function (tier, i) {
      tier.addEventListener('mouseenter', function () { activate(i); });
      tier.addEventListener('focus', function () { activate(i); });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-gc-cleanse]');
    for (var i = 0; i < roots.length; i++) initCleanse(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gc-cleanse]');
    if (root) initCleanse(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (!root || root.__gcHeroInit) return;
    root.__gcHeroInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gc-dot]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === current;
        s.classList.toggle('gc-hero-slide--active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var active = i === current;
        d.classList.toggle('gc-dot--active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
        var fill = d.querySelector('.gc-dot__fill');
        if (fill) {
          fill.style.animation = 'none';
          void fill.offsetWidth;
          fill.style.animation = '';
        }
      });
    }

    function advance() { show(current + 1); }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); });
      var fill = d.querySelector('.gc-dot__fill');
      if (fill) {
        fill.addEventListener('animationend', function () {
          if (!reduce && d.classList.contains('gc-dot--active')) advance();
        });
      }
    });

    if (slides.length) show(0);

    var parallaxRoot = root;
    if (!reduce) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = parallaxRoot.getBoundingClientRect();
          var offset = Math.max(-120, Math.min(120, -rect.top * 0.2));
          parallaxRoot.style.setProperty('--gc-parallax-y', offset + 'px');
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-gc-hero]');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gc-hero]');
    if (root) initHero(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-home-our-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStory(root) {
    if (!root || root.__gcStoryInit) return;
    root.__gcStoryInit = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var rect = root.getBoundingClientRect();
        var offset = Math.max(-100, Math.min(100, -rect.top * 0.2 + 100));
        root.style.setProperty('--gc-parallax-y', offset + 'px');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  function initAll() { document.querySelectorAll('[data-gc-story]').forEach(initStory); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-gc-story]'); if (r) initStory(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-home-stockists"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStk(root) {
    if (!root || root.__gcStkInit) return;
    root.__gcStkInit = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gc-stk-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.gc-stk__item'));
    if (!tabs.length) return;
    function activate(region) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-region') === region;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      items.forEach(function (it) { it.hidden = it.getAttribute('data-region') !== region; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-region')); }); });
  }
  function initAll() { document.querySelectorAll('[data-gc-stockists]').forEach(initStk); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-gc-stockists]'); if (r) initStk(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-shop-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcSortInit) return; root.__gcSortInit = true;
    var toggle = root.querySelector('[data-gc-sort-toggle]');
    var menu = root.querySelector('[data-gc-sort-menu]');
    var grid = root.querySelector('[data-gc-grid]');
    if (!toggle || !menu || !grid) return;
    toggle.addEventListener('click', function () { menu.hidden = !menu.hidden; });
    document.addEventListener('click', function (e) { if (!root.querySelector('[data-gc-sort]').contains(e.target)) menu.hidden = true; });
    var original = Array.prototype.slice.call(grid.querySelectorAll('.gc-scard'));
    menu.querySelectorAll('[data-gc-sort-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        menu.querySelectorAll('[data-gc-sort-opt]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        menu.hidden = true;
        var key = opt.getAttribute('data-gc-sort-opt');
        var cards = original.slice();
        if (key === 'price-low-to-high') cards.sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
        else if (key === 'price-high-to-low') cards.sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
        cards.forEach(function (c) { grid.appendChild(c); });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-gc-shopgrid]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-svc-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcSvcInit) return; root.__gcSvcInit = true;
    try {
      // ── accordions ──────────────────────────────────────────────────────
      root.querySelectorAll('[data-gc-acc]').forEach(function (acc) {
        var head = acc.querySelector('[data-gc-acc-toggle]');
        var body = acc.querySelector('.gc-svcacc__body');
        if (!head || !body) return;
        head.addEventListener('click', function () {
          var open = head.getAttribute('aria-expanded') === 'true';
          head.setAttribute('aria-expanded', open ? 'false' : 'true');
          body.hidden = open;
        });
      });

      // ── variant selection → price ───────────────────────────────────────
      var priceEl = root.querySelector('[data-gc-price]');
      var radios  = root.querySelectorAll('[data-gc-variant]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!priceEl) return;
          var next = r.dataset.gcPriceValue;
          if (!next || next === priceEl.textContent.trim()) return;
          priceEl.classList.add('is-swapping');
          window.setTimeout(function () {
            priceEl.textContent = next;
            priceEl.classList.remove('is-swapping');
          }, 160);
        });
      });

      // ── submit: guard, pending state, readable failure ───────────────────
      var form   = root.querySelector('[data-gc-form]');
      var submit = root.querySelector('[data-gc-submit]');
      var errEl  = root.querySelector('[data-gc-error]');
      function showErr(msg) {
        if (!errEl) return;
        errEl.textContent = msg;
        errEl.hidden = false;
      }
      function clearErr() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }
      function resetSubmit() {
        if (!submit) return;
        submit.disabled = false;
        submit.textContent = submit.dataset.gcLabel || submit.textContent;
      }
      if (form && submit) {
        submit.dataset.gcLabel = submit.textContent.trim();
        form.addEventListener('submit', function (e) {
          clearErr();
          // aria-disabled is advisory — it does not block selection or submission.
          var checked = form.querySelector('[data-gc-variant]:checked');
          if (checked && checked.getAttribute('aria-disabled') === 'true') {
            e.preventDefault();
            showErr("That option isn’t available right now. Choose another, or call us and we’ll sort it out.");
            return;
          }
          var consent = form.querySelector('[data-gc-consent]');
          if (consent && !consent.checked) {
            e.preventDefault();
            showErr('Please confirm you are the parent or guardian before adding this to your cart.');
            return;
          }
          e.preventDefault();
          submit.disabled = true;
          submit.textContent = 'ADDING…';
          // FormData carries line-item properties; a hand-built body drops them silently.
          window.fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok) throw new Error(data.description || data.message || 'That could not be added to your cart.');
                window.location.href = '/cart';
              });
            })
            .catch(function (err) {
              resetSubmit();
              showErr(err.message || 'That could not be added to your cart. Please try again.');
            });
        });
        // bfcache: a back-navigation must not restore a stuck ADDING… button
        window.addEventListener('pageshow', resetSubmit);
      }
    } catch (e) {
      // Shopify concatenates every section's JS into one theme-wide bundle;
      // an uncaught throw here would halt every other section's script.
      console.error('[gc-svc-product]', e);
    }
  }
  function boot() { document.querySelectorAll('[data-gc-svcproduct]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-svc-zones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__gcZonesInit) return; root.__gcZonesInit = true;
    root.querySelectorAll('[data-gc-zone]').forEach(function (zone) {
      var head = zone.querySelector('[data-gc-zone-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var was = zone.classList.contains('is-open');
        root.querySelectorAll('[data-gc-zone]').forEach(function (z) { z.classList.remove('is-open'); });
        if (!was) zone.classList.add('is-open');
      });
    });
  }
  function boot() { document.querySelectorAll('[data-gc-zones]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
